import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { GridOptions } from 'ag-grid-community';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EditDeleteRendererComponent } from '../../components/edit-delete-renderer/edit-delete-renderer.component';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-zendesk-comments',
  templateUrl: './zendesk-comments.component.html',
  styleUrls: ['./zendesk-comments.component.css']
,
  standalone: false
})
export class ZendeskCommentsComponent implements OnInit {
  currentuser: any;
  username: any;
  readOnlyUser: boolean = false;
  commentsList: any[] = [];
  gridOptions: GridOptions;
  columnDefs: any;
  rowData: any;
  defaultColDef: any;
  domLayout = '';
  privilegeName: any = '';
  modalRef: NgbModalRef;
  popupHeading;
  action = '';
  updatedComments: any;
  showNameError: boolean = false;
  showDescriptionError: boolean = false;
  showValueError: boolean = false;
  commentName: string = '';
  commentDescription: string = '';
  commentValue: string = '';
  obj: {};
  commentId: any;
  originalCommentValue: any;
  @ViewChild('comment', { static: false }) adcomment: ElementRef<any>;
  @ViewChild('commentEdit', { static: false }) editcomment: ElementRef<any>;


  constructor(    
    public authService: AuthenticationService,
    public spinner: SpinnerService,
    public restService: RestService,
    private ngbModalService: NgbModal,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private http: HttpClient
    ) { }

  ngOnInit(): void {
    this.getComments()
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }


  getComments(){
    this.spinner.activate();
    this.commentsList = [];
    this.restService.getRequest(AppSettings.GET_COMMENTS,'').subscribe((response)=>{
      let list = response;
      let listLength = list.length
      for(let i=0; i<listLength; i++){
        this.obj = {
          'id' : list[i].id,
          'name' : list[i].name,
          'description' : list[i].description,
          'value' : list[i].value
        }
        this.commentsList?.push(this.obj);
        }
        this.gridOptions = {
          defaultColDef: {
            resizable: true,
            sortable: true,
            filter: true,
            headerClass: "headerClass"
          },
          columnDefs: [
            { headerName: 'ID', field: 'id', width: 30},
            { headerName: 'Name', field: 'name',width:80},
            { headerName: 'Description', field: 'description',width:85},
            { headerName: 'Value', field: 'value'},
            {
              headerName: 'Action', field: 'action', width:45,cellStyle:{ textAlign: 'center' },cellRenderer: EditDeleteRendererComponent,
              cellRendererParams: {
                onEditClick: this.onEditClick.bind(this),
                // onDeleteClick: this.onDeleteClick.bind(this),
                showZenEdit: true,
                showZenDelete: true,
                componentIdentifier: 'zendesk'
              }
            }
  
          ],
          rowData: this.commentsList,
        }
        this.spinner.deactivate();
      }, 
      // (err) => {
      //   this.spinner.deactivate();
      //   if (err.error && err.error.message && err.error.message.length > 0) {
      //     this.toastr.error(err.error.message, 'Error');
      //   } else {
      //     this.toastr.error('Session Expired Please login again.', 'Error');
      //   }
      // }
      // );
  
       
    // }
    )
  }

  onAddComment() {
    this.action = 'add';
    this.commentName = '';
    this.commentDescription = '';
    this.commentValue = '';
    this.popupHeading = 'Add Comment';

    this.showNameError = false;
    this.showDescriptionError = false;
    this.showValueError = false;

    this.modalRef = this.ngbModalService.open(this.adcomment);
  }

  onEditClick(id:any) {
    this.action = 'edit';
    this.popupHeading = 'Edit Zendesk Comment';
    let item = this.commentsList.find(item => item.id === id);
    this.originalCommentValue = item.value;
    this.commentId = item.id;
    this.commentName = item.name;
    this.commentDescription = item.description;
    this.commentValue =  item.value;
    this.modalRef = this.ngbModalService.open(this.editcomment);
  }

  saveComment(commentId){

    if (this.action == 'add') {
      let model = {
        name: this.commentName,
        description: this.commentDescription,
        value: this.commentValue
      }
      this.spinner.activate();
      this.restService.postRequest(AppSettings.ADD_COMMENTS,model).subscribe((response)=>{
        this.commentName = '',
        this.commentDescription = '',
        this.commentValue = ''
        this.getComments();
        this.modalService.dismissAll();
        this.toastr.success('Zendesk Comment added successfully', 'Success');
        this.spinner.deactivate();
      }, (err) => {
        this.spinner.deactivate();
        if (err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      }
      )
      this.modalService.dismissAll();
    }
    let url = AppSettings.API_ENDPOINT + '/'+ AppSettings.UPDATE_COMMENTS+'/'+commentId
    if(this.action == 'edit'){
    let model = {
      value: this.commentValue
    }
    this.spinner.activate();
    this.http.put(url,model).subscribe((response)=>{
      this.updatedComments = response
      this.commentValue = '';
      this.getComments();
      this.modalService.dismissAll();
      this.toastr.success('Zendesk Comment updated successfully', 'Success');
      this.spinner.deactivate();
    }, (err) => {
      this.spinner.deactivate();
      if (err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error('Session Expired Please login again.', 'Error');
      }
    })
    }
  }

  onFieldChange(field: string) {
    if (field === 'name') {
      this.showNameError = true;
    } else if (field === 'description') {
      this.showDescriptionError = true;
    } else if (field === 'value') {
      this.showValueError = true;
    }
  }


}
